import Grid from '@material-ui/core/Grid'
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data'
import {
  Agenda,
  Day,
  Inject,
  Month,
  ScheduleComponent,
  ViewDirective,
  ViewsDirective,
  Week,
  WorkWeek,
} from '@syncfusion/ej2-react-schedule'
import moment from 'moment'
import 'moment/locale/pt-br' // without this line it didn't work
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import PageLayout from '../../components/PageLayout'
import useTypedSelector from '../../hooks/useTypedSelector'
import schedule from '../../services/schedule'
import { StoreState } from '../../store'
import { getPeople } from '../../store/people/peopleActions'
import { PeopleActionTypes } from '../../store/people/peopleTypes'
import { corEvent, sendEmail } from '../../store/schedule/scheduleActions'

moment.locale('pt-br')

let data = new DataManager({
  url: `${schedule}/GetData`,
  crudUrl: `${schedule}/BatchData`,
  adaptor: new UrlAdaptor(),
  crossDomain: true,
})
let idChurch = ''
let emailUser = ''
let churchName = ''

export function getSchedule(): ThunkAction<
  Promise<void>,
  StoreState,
  undefined,
  Action
> {
  return async (dispatch, getState) => {
    const { selectedChurchIndex, user } = getState().sessionState
    const churchId = user?.churches?.[selectedChurchIndex]?.id
    idChurch = churchId
    const email = user?.email
    emailUser = email
    const name = user?.churches?.[selectedChurchIndex]?.name
    churchName = name
  }
}

export default function DashboardDetails() {
  const dispatch = useDispatch()
  const people = useTypedSelector(({ peopleState }) => peopleState.people)

  const reducerPeople = useMemo(() => {
    return people.reduce((acc, cur) => {
      if (cur.email !== '') {
        acc.push({ name: cur.name, email: cur.email })
      }
      return acc
    }, [])
  }, [people])

  let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  let churchObject = [
    { timeZone: timeZone },
    { idChurch: idChurch },
    { emailUser: emailUser },
    { churchName: churchName },
    ...reducerPeople,
  ]

  let dataQuery = new Query()
    .from('Events')
    .addParams('churchObject', JSON.stringify(churchObject))

  useEffect(() => {
    dispatch(getSchedule())
  }, [dispatch])

  const onMountPage = () => dispatch(getPeople())
  const onUnmountPage = () => dispatch({ type: PeopleActionTypes.CLEAR })

  return (
    <>
      <Grid container>
        <div>
          <PageLayout
            details={<></>}
            onMountPage={onMountPage}
            onUnmountPage={onUnmountPage}
          />
        </div>

        <Grid item xs={12} md={12}>
          <div>
            <div style={{ backgroundColor: '#fff', width: '100%' }}>
              <ScheduleComponent
                eventSettings={{
                  dataSource: data,
                  query: dataQuery,
                }}
                height="85vh"
                locale="pt"
                selectedDate={new Date()}
                popupOpen={sendEmail}
                eventRendered={corEvent}
              >
                <ViewsDirective>
                  <ViewDirective option="Day" displayName="Dia" />
                  <ViewDirective option="Week" displayName="Semana" />
                  <ViewDirective option="Month" displayName="Mês" />
                </ViewsDirective>

                <Inject services={[Day, Week, WorkWeek, Month, Agenda]} />
              </ScheduleComponent>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  )
}
